/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ included: NonNullable<unknown>, used: NonNullable<unknown>, percent: NonNullable<unknown>, overage: NonNullable<unknown> }} Receipt_Usage_ExplainedInputs */



/**
* | output |
* | --- |
* | "{included} included credit · {used} used ({percent}%) · {overage} overage" |
*
* @param {Receipt_Usage_ExplainedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_usage_explained = /** @type {((inputs: Receipt_Usage_ExplainedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Usage_ExplainedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.included} Guthaben enthalten · ${i?.used} genutzt (${i?.percent} %) · ${i?.overage} Überschreitung`)
	return /** @type {LocalizedString} */ (`${i?.included} included credit · ${i?.used} used (${i?.percent}%) · ${i?.overage} overage`)
});